import { put, select, all, take, takeLatest } from 'redux-saga/effects';
import { GET_CHANNELS, GET_CHANNELS_SUCCESSFUL, RECALL_ACTIONS_FAIL } from '../types/global';
import {
  // REFRESH_TOKEN
  REFRESH_TOKEN_SUCCESS,
} from '../types/authenticate';
import { onFailRequest } from '../../utils';
import { requestGetChannels } from '../requests/channels';

/**
 * This function is resolve request actions were failed
 * because the token of requests were failed or expired
 * then re-call functions fail again when token has refreshed
 */
function* watchRecallActionsFail() {
  try {
    while (true) {
      const { global } = yield select();
      const action = yield take('*');
      // console.log('watchRefreshTokenAction - action', action);
      // console.log('watchActions - state  global :', global);
      if (action.type === REFRESH_TOKEN_SUCCESS && global.actionsFailed.length) {
        // get actions failed
        const runActions = global.actionsFailed.map((el) => put(el));
        // console.log('watchActions -  runActions :', runActions);
        // Push actions failed to store then re-call those actions
        yield all([
          ...runActions,
          put({
            type: RECALL_ACTIONS_FAIL,
            action: null,
          }),
        ]);
      }
    }
  } catch (err) {
    // console.error('watchActions - err', err);
  }
}

/**
 * Get channels
 * @param {*} payload
 */
function* getChannels(payload) {
  try {
    const { data } = yield requestGetChannels();
    yield put({
      type: GET_CHANNELS_SUCCESSFUL,
      payload: data.length ? data : [],
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
    });
  }
}

export default [watchRecallActionsFail(), takeLatest(GET_CHANNELS, getChannels)];
